import {
  REACT_APP_FEATURE_FLAG_ADD_PARTICIPANT_LINK,
  REACT_APP_FEATURE_FLAG_AUTOMATIC_CANCELLATION,
  REACT_APP_FEATURE_FLAG_CASES_TCP,
  REACT_APP_FEATURE_FLAG_DECLARATION_INADMISSIBILITY,
  REACT_APP_FEATURE_FLAG_DOWNLOAD_LINK_EXCEL_RESULT,
  REACT_APP_FEATURE_FLAG_ENABLE_SURVEY,
  REACT_APP_FEATURE_FLAG_HABILITY_V3,
  REACT_APP_FEATURE_FLAG_NOTIFICATION_PROVIDER,
  REACT_APP_FEATURE_FLAG_ORGANIZATION_SELECT,
  REACT_APP_FEATURE_FLAG_PARTICIPANT_LINK,
  REACT_APP_FEATURE_FLAG_PURCHASE_ORDER_SECTION_SUMMARY,
  REACT_APP_FEATURE_FLAG_REGIONS_TAG,
  REACT_APP_FEATURE_FLAG_SERVICES_ATTACH,
  REACT_APP_FEATURE_FLAG_SERVICES_EXCEL,
  REACT_APP_FEATURE_FLAG_SERVICES_MAX_DATE,
  REACT_APP_FEATURE_FLAG_SERVICES_SEARCH,
  REACT_APP_FEATURE_FLAG_BUYER_ATTACHMENTS_RESTRICTED_TO_SAVED_STATE
} from '../../config/settings/environment'

export const features = {
  'declaration.inadmissibility':
    REACT_APP_FEATURE_FLAG_DECLARATION_INADMISSIBILITY === true ||
    REACT_APP_FEATURE_FLAG_DECLARATION_INADMISSIBILITY === 'true',
  'download.link.excel.result':
    REACT_APP_FEATURE_FLAG_DOWNLOAD_LINK_EXCEL_RESULT === true ||
    REACT_APP_FEATURE_FLAG_DOWNLOAD_LINK_EXCEL_RESULT === 'true',
  'organization.select':
    REACT_APP_FEATURE_FLAG_ORGANIZATION_SELECT === true || REACT_APP_FEATURE_FLAG_ORGANIZATION_SELECT === 'true',
  'services.attach':
    REACT_APP_FEATURE_FLAG_SERVICES_ATTACH === true || REACT_APP_FEATURE_FLAG_SERVICES_ATTACH === 'true',
  'services.excel': REACT_APP_FEATURE_FLAG_SERVICES_EXCEL === true || REACT_APP_FEATURE_FLAG_SERVICES_EXCEL === 'true',
  'services.search':
    REACT_APP_FEATURE_FLAG_SERVICES_SEARCH === true || REACT_APP_FEATURE_FLAG_SERVICES_SEARCH === 'true',
  'services.use.max.date':
    REACT_APP_FEATURE_FLAG_SERVICES_MAX_DATE === true || REACT_APP_FEATURE_FLAG_SERVICES_MAX_DATE === 'true',
  'cases.tcp': REACT_APP_FEATURE_FLAG_CASES_TCP === true || REACT_APP_FEATURE_FLAG_CASES_TCP === 'true',
  'link.participants':
    REACT_APP_FEATURE_FLAG_PARTICIPANT_LINK === true || REACT_APP_FEATURE_FLAG_PARTICIPANT_LINK === 'true',
  'link.add.participants':
    REACT_APP_FEATURE_FLAG_ADD_PARTICIPANT_LINK === true || REACT_APP_FEATURE_FLAG_ADD_PARTICIPANT_LINK === 'true',
  'regions.tag': REACT_APP_FEATURE_FLAG_REGIONS_TAG === true || REACT_APP_FEATURE_FLAG_REGIONS_TAG === 'true',
  'notification.provider':
    REACT_APP_FEATURE_FLAG_NOTIFICATION_PROVIDER === true || REACT_APP_FEATURE_FLAG_NOTIFICATION_PROVIDER === 'true',
  'automatic.cancellation':
    REACT_APP_FEATURE_FLAG_AUTOMATIC_CANCELLATION === true || REACT_APP_FEATURE_FLAG_AUTOMATIC_CANCELLATION === 'true',
  'service.hability.v3': REACT_APP_FEATURE_FLAG_HABILITY_V3 === true || REACT_APP_FEATURE_FLAG_HABILITY_V3 === 'true',
  'enable.survey': REACT_APP_FEATURE_FLAG_ENABLE_SURVEY === true || REACT_APP_FEATURE_FLAG_ENABLE_SURVEY === 'true',
  'feature.show.purchase.order.section.summary':
    REACT_APP_FEATURE_FLAG_PURCHASE_ORDER_SECTION_SUMMARY === true ||
    REACT_APP_FEATURE_FLAG_PURCHASE_ORDER_SECTION_SUMMARY === 'true',
  'attachments.restricted.to.saved.state':
    REACT_APP_FEATURE_FLAG_BUYER_ATTACHMENTS_RESTRICTED_TO_SAVED_STATE === true ||
    REACT_APP_FEATURE_FLAG_BUYER_ATTACHMENTS_RESTRICTED_TO_SAVED_STATE === 'true'
}
